import _ from 'underscore';

import {makeDefaultItem} from 'notebook/notes/CreateOps';
import {GridPlaceholderNotePart} from 'notebook/notes/groups/note-part-grid/NotePartGridGroupConstants';
import NoteConstants from 'notebook/notes/NoteConstants';
import {FromServerNoteLinkedFile} from 'notebook/util/NoteUtilConstants';

import {DEFAULT_GRID_PLACEHOLDER_WIDTH} from './imageTypeUtils';

const {NOTE_LINKED_OBJECT} = NoteConstants;

export function makeGridPlaceholderNotePart(
  taskId: string,
  fileUploadDeferred?: JQueryPromise<FromServerNoteLinkedFile>,
  fileName?: string
): GridPlaceholderNotePart {
  return {
    ...makeDefaultItem(NOTE_LINKED_OBJECT),
    alignment: 'left' as const,
    placeholder: true,
    taskId,
    cid: _.uniqueId('grid-placeholder-'),
    item: null,
    item_id: null,
    itemWidth: DEFAULT_GRID_PLACEHOLDER_WIDTH,
    _fileUploadDeferred: fileUploadDeferred,
    _fileName: fileName,
  };
}
